import React from 'react';
import OpportunityList from '../components/opportunities/OpportunityList';

const OpportunityListPage = () => {
  return <OpportunityList />;
};

export default OpportunityListPage;
